import { CommonModule, DOCUMENT } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	Inject,
	NgModule,
	OnDestroy,
	OnInit,
	Renderer2,
	inject,
} from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { EventBusEvents } from '@siza-staff-care/event-bus-constants';
import { AppStateService } from '@siza-staff-care/shared/app-state';
import { NoState } from '@siza-staff-care/shared/data';
import { SnackbarService } from '@siza-staff-care/shared/ui-components/common-ui';
import { WebAppShellModule } from '@siza-staff-care/web-app/shell';
import { HotkeyModule } from 'angular2-hotkeys';
import { MetaData, NgEventBus } from 'ng-event-bus';
import { Observable, delay, takeUntil, tap } from 'rxjs';

@Component({
	selector: 'sc-app',
	template: `
		@if (appState.vm$ | async; as vm) {
			<sh-shell />
			<hotkeys-cheatsheet title="Keyboard shortcuts" />
		}
	`,
	styles: [
		`
			:host {
				display: block;
				height: 100vh;
			}
		`,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent extends ComponentStore<NoState> implements OnInit, OnDestroy {
	protected appState = inject(AppStateService);
	private renderer = inject(Renderer2);
	private eventBus = inject(NgEventBus);
	private snackbar = inject(SnackbarService);

	constructor(@Inject(DOCUMENT) private document: Document) {
		super({});

		this.listenForTOTPSetupComplete(this.eventBus.on(EventBusEvents.Event_TOTP_Setup_Complete));
	}

	ngOnInit() {
		this.appState.vm$
			.pipe(
				takeUntil(this.destroy$),
				tap((vm) => {
					vm.isPaintingSecurity
						? this.renderer.addClass(this.document.body, 'security-design-mode')
						: this.renderer.removeClass(this.document.body, 'security-design-mode');

					vm.isPaintingWorkflowSecurity
						? this.renderer.addClass(this.document.body, 'workflow-design-mode')
						: this.renderer.removeClass(this.document.body, 'workflow-design-mode');
				}),
			)
			.subscribe();
	}

	private readonly listenForTOTPSetupComplete = this.effect((event$: Observable<MetaData>) =>
		event$.pipe(
			delay(350), // Allow dialog to close
			tap(() => {
				this.snackbar.showMessage('Authenticator setup complete');
			}),
		),
	);
}

@NgModule({
	imports: [CommonModule, WebAppShellModule, HotkeyModule],
	declarations: [AppComponent],
	exports: [AppComponent],
})
export class AppComponentModule {}
